import React, { Component } from 'react';
import { connect } from 'react-redux';

import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import Logger, {LOG_LEVELS} from '../../utils/logger';
import FormattedCurrencyValue from '../fields/number/FormattedCurrencyValue';
import Collapsible from 'react-collapsible';
import { withFullStoryExclude } from '../../utils/fullStoryHelper';
const log = new Logger('TRANSACTION_REPORT_RCL', LOG_LEVELS.DEBUG);

class ReportRCL extends Component {

  render() {
    log.debug('render(): ', this.props);

    if (this.props.src.length === 0) {
      return(
        <div><LanguageStringResolver string='transactionBlank_noData'/></div>
      )
    }

    return(
      <table className="mb20">
        <thead>
          <tr>
            <th><span><LanguageStringResolver string='transactionInvoice_country'/></span></th>
            <th><span><LanguageStringResolver string='transactionInvoice_VATNumber'/></span></th>
            <th><span><LanguageStringResolver string='transactionInvoice_TaxableBasis'/></span></th>
            <th><span><LanguageStringResolver string='transactionInvoice_VATReversed'/></span></th>
            <th><span><LanguageStringResolver string='transactionInvoice_currency'/></span></th>
          </tr>
        </thead>
        <tbody>
          {this.props.src.map((item, index) => (
            <tr key={index}>
              <td>{item.country}</td>
              <td>{item.vatNumber}</td>
              <td><FormattedCurrencyValue inputFieldClassName={withFullStoryExclude()} value={item.taxableBasis}/></td>
              <td><FormattedCurrencyValue inputFieldClassName={withFullStoryExclude()} value={item.vatReversed}/></td>
              <td>{item.currency}</td>
            </tr>
          ))}
        </tbody>
      </table>
   );
  }
}

function mapStateToProps(state, props) {
  log.debug('mapStateToProps(): state & starting props', state, props);
  return {};
}


function mapDispatchersToProps(dispatch) {
  return {}
}

// This connects mapStateToProps and mapDispatchersToProps into Redux, effectively plumbing the Page to the app state
export default connect(mapStateToProps, mapDispatchersToProps)(ReportRCL);
